import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBoxComment, DBTextField } from '_components';


const components = {

}

class PatientCareCenterNoteObjectiveObsRespiratoryPeds extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }

    handleDiagChangePattern(event) {
        if (event.target.value === '-1') {
            this.props.clearField(this.props.noteId, 'PTOBJECTIVEPEDS', 'OPNO', this.props.opno, 'OPRESPATTERN');
        }
        else if (event.target.value !== this.props.diagVal) {
            this.props.updateTextField(this.props.noteId, 'PTOBJECTIVEPEDS', 'OPNO', this.props.opno, 'OPRESPATTERN', event.target.value);
        }
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='obj_obs_respiratory' name='Respiratory' level={2} noChildPadding={true}>
                <div className={styles.row}>
                    <span className={styles.padding_spacer}></span>
                    <label className={styles.label_reg}>Pattern</label>
                    <select className={styles.diag_drop_down} value={this.props.patternValue ? this.props.patternValue : '-1'} onChange={(event) => this.handleDiagChangePattern(event)}>
                        <option key={-1} value='-1'></option>
                        <option key={1} value='1'>Abdominal</option>
                        <option key={2} value='2'>Lateral Costal</option>
                        <option key={3} value='3'>Thoracic Expansion</option>
                        <option key={4} value='4'>WNL</option>
                    </select>
                </div>
                <div className={styles.row}>
                    <label className={styles.header_bold}>Rate</label>
                </div>

                <div className={styles.row}>
                    <span className={styles.padding_spacer}></span>
                    <label className={styles.label_reg}>At rest</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDS'
                        entityKeyColumn='OPNO'
                        entityKeyValue={this.props.opno}
                        field='OPRESRATEATREST'
                        className={styles.col2}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.padding_spacer}></span>
                    <label className={styles.label_reg}>In activity</label>
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDS'
                        entityKeyColumn='OPNO'
                        entityKeyValue={this.props.opno}
                        field='OPRESRATEINACTIVITY'
                        className={styles.col2}
                    />
                </div>

                <div className={styles.form_row}>
                    <div className={styles.gap}>
                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPRESCOORDRATEFUN'
                            className={styles.checkbox}
                            label='Coordinates rate with function'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>
                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPRESHOLDBREATH'
                            className={styles.checkbox}
                            label='Hold breath during movement'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={styles.gap}>
                        <DBCheckBoxComment
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPRESRIBCAGE'
                            className={styles.checkbox}
                            label='Rib cage mobility'
                            textAreaStyle={styles.formTextArea}
                        />
                    </div>
                </div>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));

    let patternValue = state.entities.notes.PTOBJECTIVEPEDS[opno].OPRESPATTERN !== null ? state.entities.notes.PTOBJECTIVEPEDS[opno].OPRESPATTERN : undefined;
    return {
        noteId: noteId,
        opno: opno,
        patternValue: patternValue
    };
}

const connectedPatientCareCenterNoteObjectiveObsRespiratoryPeds = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveObsRespiratoryPeds);
export { connectedPatientCareCenterNoteObjectiveObsRespiratoryPeds as PatientCareCenterNoteObjectiveObsRespiratoryPeds };

